import { render, staticRenderFns } from "./sidemenu.vue?vue&type=template&id=182f41f2&scoped=true"
import script from "./sidemenu.vue?vue&type=script&lang=js"
export * from "./sidemenu.vue?vue&type=script&lang=js"
import style0 from "./sidemenu.vue?vue&type=style&index=0&id=182f41f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182f41f2",
  null
  
)

export default component.exports